import { memo, type FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { SymbolName } from "../utils/cardSymbols";
import type { IconName } from "@fortawesome/fontawesome-svg-core";

interface SymbolBoxProps {
  symbol: SymbolName;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-5 h-5 text-xs",
  md: "w-7 h-7 text-base",
  lg: "w-9 h-9 text-lg",
};

const SymbolBoxComponent: FC<SymbolBoxProps> = ({
  symbol,
  size = "md",
  className = "",
}) => {
  return (
    <div
      className={`
        flex items-center justify-center
        border border-white/30 rounded
        bg-white/5
        ${sizeClasses[size]}
        ${className}
      `}
    >
      <FontAwesomeIcon
        icon={["fas", symbol as IconName]}
        className="text-white/90"
      />
    </div>
  );
};

// Memoize SymbolBox since symbols don't change frequently
export const SymbolBox = memo(SymbolBoxComponent);

interface SymbolRowProps {
  symbols: [SymbolName, SymbolName, SymbolName];
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const SymbolRow = memo(function SymbolRow({
  symbols,
  size = "md",
  className = "",
}: SymbolRowProps) {
  return (
    <div className={`flex justify-center gap-1 ${className}`}>
      {symbols.map((symbol, index) => (
        <SymbolBox key={`${symbol}-${index}`} symbol={symbol} size={size} />
      ))}
    </div>
  );
});
